import React from "react";

interface LoadingProps {
  view: string;
}

export const LoadingWheel: React.FC<LoadingProps> = ({ view }) => {
  let p1 = "Revisando algo indefinido.";
  let p2 = "Espera un poco mientras revisamos...";
  if (view === "login") {
    p1 = "Revisando cookies de sesión en Ruuf.";
    p2 = "Por favor espera mientras validamos tu información...";
  } else if (view === "home") {
    p1 = "Revisando el estado de tus cotizaciones.";
    p2 = "Por favor espera mientras checkeamos todo...";
  }
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-t-4 border-blue-500 border-solid"></div>
      <p className="text-xl mt-5 text-center">{p1}</p>
      <p className="text-xl mt-5 text-center">{p2}</p>
    </div>
  );
};
